<template lang="pug">
.pagination(v-if="results.totalResultCount > 0")
  component.pagination__prev(
    @click.stop.prevent="enablePrev ? moveIndex(-1) : false",
    :is="enablePrev ? 'a' : 'span'",
    :data-active="enablePrev",
    aria-label="Previous results page"
  )
  div {{ currentResultsStart }} - {{ currentResultsEnd }} of {{ totalResultCount }}
  component.pagination__next(
    @click.stop.prevent="enableNext ? moveIndex(1) : false",
    :is="enableNext ? 'a' : 'span'",
    :data-active="enableNext",
    aria-label="Next results page"
  )
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "SearchPagination",
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "searchQuery",
      "results",
      "currentResultsStart",
      "currentResultsEnd",
      "totalResultCount"
    ]),
    currentPage() {
      return this.searchQuery.currentPage;
    },
    enablePrev() {
      return this.currentPage > 0;
    },
    enableNext() {
      return this.currentPage < this.results.totalPages - 1;
    },
  },
  methods: {
    ...mapMutations(["setPageIndex"]),
    checkPaginationVisibility(i) {
      let cp = this.currentPage;
      let tp = this.results.totalPages;

      if (tp <= 9) return true;
      if (i === 0) return true
      if (i === tp - 1) return true

      if (cp < 4) {
        if (i < 4) return true;
      }

      if (Math.abs(cp - i) <= 2) return true

      if (cp > tp - 5) {
        if (i > tp - 5) return true;
      }

      return false;
    },
		topScroll() {
			let content = document.querySelector('.content');
			setTimeout(() => {
				document.body.scrollTop = content.offsetTop;
				document.documentElement.scrollTop = content.offsetTop;
			},500);
		},
    selectIndex(index) {
      this.setPageIndex(index);
      this.submitPage();
			this.topScroll();
    },
    moveIndex(increment) {
      this.setPageIndex(this.currentPage + increment);
      this.submitPage();
			this.topScroll();
    },
    submitPage() {
      this.$emit("submitpage");
    },
    keyboardNavigation(e) {
      if (e.code == "ArrowRight" && this.enableNext) {
        this.moveIndex(1);
        this.submitPage;
      }
      if (e.code == "ArrowLeft" && this.enablePrev) {
        this.moveIndex(-1);
        this.submitPage;
      }
    },
  },
  created() {
    let previousEventCallback = window.searchPaginationKeyboardEvent || false;
    let newEventCallback = this.keyboardNavigation;
    if (previousEventCallback) {
      window.removeEventListener("keydown", previousEventCallback);
    }
    window.addEventListener("keydown", newEventCallback);
    window.searchPaginationKeyboardEvent = this.keyboardNavigation;
  },
};
</script>
<style lang="scss" scoped>
.pagination {
	display: flex;
	align-items: center;
	justify-content: space-between;
	grid-area: span 1 / span 1;
	align-self: start;
	font-size: 1rem;

	@include mq(md) {
		justify-content: flex-start;
	}

	&__prev,
	&__next {
		@include fluid(width, 1rem, 2rem);
		@include fluid(height, 1rem, 2rem);
		@include fluid(font-size, 0.875rem, 1rem);
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 0.25rem;
		color: $darkGray;
		transition: 0.2s ease;
		cursor: pointer;

		&::before {
			display: none;
		}

		&::after {
			font-size: 1.25rem;
		}

		span {
			@include hideVisually;
		}

		&:not([data-active]) {
			color: $darkGray;
			cursor: pointer;

			&:hover {
				text-decoration: none;
				color: $darkGray;
				cursor: not-allowed;
			}
		}

		&:hover {
			color: $darkBlue;
			text-decoration: none;
		}
	}

	&__prev {
		margin-right: 0.5rem;
		margin-left: 0;
		background: url("../img/template-images/page_left.gif") no-repeat center;
	}

	&__next {
		margin-left: 0.5rem;
		margin-right: 0;
		background: url("../img/template-images/page_right.gif") no-repeat center;
	}

	&__numbers {
		@include fluid(margin-left, -0.125rem, -0.25rem);
		@include fluid(margin-right, -0.125rem, -0.25rem);
		display: flex;
	}

	&__number {
		@include fluid(width, 1.375rem, 3.5rem);
		@include fluid(height, 1.375rem, 3.5rem);
		@include fluid(font-size, 1rem, 1.125rem);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: default;
		line-height: 1;
		margin-top: 0;
		margin-bottom: 0;
		padding: 0;
		transition: 0.2s ease;
		border-top: 3px solid transparent;
		border-bottom: 3px solid transparent;

		&::before {
			display: none;
		}

		&--active {
			background-color: $darkBlue;
			color: $white;
			font-weight: 700;
		}
	}

	&__ellipsis {
		display: flex;
		align-items: center;
		justify-content: center;
		align-self: center;
		padding: 0.25rem;

		&+& {
			display: none;
		}
	}

	a.pagination__number {
		cursor: pointer;
		color: $darkGray;

		&:hover {
			text-decoration: none;
			background-color: $blue;
			color: $white;
		}
	}
}
</style>
